import React from 'react';
import { TFunction } from 'i18next';
import SupportiveMessage, {
  SupportiveMessageColor,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import styles from '../QuestionFieldPreviewByKind.module.scss';

interface AttachmentPreviewProps {
  t: TFunction<'translation', undefined>;
  required?: boolean;
}

export default function AttachmentPreview({
  t,
  required = false,
}: AttachmentPreviewProps) {
  return (
    <div>
      <Button
        buttonType={ButtonTypes.secondaryOutlined}
        buttonSize={ButtonSizes.large}
        buttonText={t('upload-file')}
        leftIcon="upload"
        disabled
      />
      {required && (
        <div className={styles.attachmentOfflineMessage}>
          <SupportiveMessage
            color={SupportiveMessageColor.Yellow}
            text={t('attachment-field-offline-text')}
          />
        </div>
      )}
    </div>
  );
}
